module.exports = __webpack_public_path__ + "static/img/logo-sfm.7d02e11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company/logo-sfm.jpg
// module id = MHiv
// module chunks = 1